// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1BLi6","amount":"Amount_amount__3use5","tip":"Amount_tip__3pK55","tipHeader":"Amount_tipHeader__3eDJs","tipsWrap":"Amount_tipsWrap__kaXAf"};